import React, { createContext, useState, useEffect } from 'react';

export const AdminContext = createContext();

export function AdminProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState('');

  // Initialize token from localStorage in useEffect to avoid webpack compilation issues
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const savedToken = localStorage.getItem('adminToken') || '';
      setToken(savedToken);
    }
  }, []);

  useEffect(() => {
    if (token) {
      fetch('/.netlify/functions/auth-user', {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(res => res.ok ? res.json() : Promise.reject())
        .then(data => setUser(data.user))
        .catch(() => setUser(null));
    } else {
      setUser(null);
    }
  }, [token]);

  const login = (token, user) => {
    setToken(token);
    setUser(user);
    if (typeof window !== 'undefined') {
      localStorage.setItem('adminToken', token);
    }
  };
  const logout = () => {
    setToken('');
    setUser(null);
    if (typeof window !== 'undefined') {
      localStorage.removeItem('adminToken');
    }
  };

  return (
    <AdminContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
}